import { render, staticRenderFns } from "./emailList.vue?vue&type=template&id=fb5f149e&"
import script from "./emailList.vue?vue&type=script&lang=js&"
export * from "./emailList.vue?vue&type=script&lang=js&"
import style0 from "./emailList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports